function sendDimensions(dimensions) {
    dimensions.forEach(({ name, value, custom }) => {
        if (name === 'dimension1') {
            window.ga('set', name);
        } else if (!custom) {
            window.ga('set', name, value);
        } else {
            window.ga('set', name, value, custom);
        }
    });
}

function initCustomDimensions(ga) {
    if (typeof E_CUSTOM_DIMENSIONS !== 'undefined') {
        // If analytics is already loaded
        if (typeof window.ga === 'function') {
            sendDimensions(E_CUSTOM_DIMENSIONS);
        }
    }
};

window.initCustomDimensions = initCustomDimensions;
